<template>
  <b-modal 
    id="modal-confirm-delete" 
    header-class="align-items-center px-20 py-15 danger"
    body-class="p-20"
    footer-class="px-20 py-15"
  >
    <template #modal-header>
      <div class="modal-title">
        <span class="fs-db-28">
          {{ $t('engine.managePage.delete.lblDelPage',languageEngine) }}
        </span>
      </div>
      <div
        id="close-modal-confirm-delete"
        type="button"
        class="close-modal"
        aria-label="Close"
        @click="close()"
      >
        <i class="fal fa-times"></i>
      </div>
    </template>
    <template>
      <div v-if="menuID" class="fs-sa-16">
        {{ $t('engine.managePage.delete.lblMenu',languageEngine) }}
        <span class="text-danger"> {{ menuName }} </span> ?
      </div>
      <div class="fs-sa-16">
        {{ $t('engine.managePage.delete.lblDelConfirm',languageEngine) }}
        <span class="text-danger"> {{ namePage }} </span> ?
      </div>
    </template>
    <template #modal-footer>
      <b-button variant="danger" @click.prevent="confirm()">
        <i class="far fa-trash-alt"></i>
        {{ $t('engine.managePage.delete.lblDel',languageEngine) }}
      </b-button>
      <b-button variant="default" @click="close()">
        <i class="far fa-times"></i> 
        {{ $t('engine.managePage.delete.lblCancel',languageEngine) }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    namePage: {
      type: String,
      default: "",
    },
    action: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      menuID: null,
      menuName: "",
    };
  },
  computed: {
    ...mapGetters({
      siteComponents: "design/metadata/siteComponents",
      languageEngine: "design/userPreference/languageEngine",
    }),
  },
  methods: {
    init() {
      this.menuID = this.getMenuLink();
      this.menuName = this.menuID ? this.siteComponents[this.menuID].properties.name : '';
    },
    clear() {
      this.menuID = null;
      this.menuName = "";
    },

    getMenuLink() {
      const menuID = Object.keys(this.siteComponents).find((cmpID) => {
        if (
          (this.siteComponents[cmpID].type == "FOOTER_MENU" || this.siteComponents[cmpID].type == "HEADER_MENU") &&
          this.siteComponents[cmpID].properties.link.type === "page" &&
          this.siteComponents[cmpID].properties.link.pageID === this.id
        ) {
          return true;
        }
      });
      return menuID;
    },

    close() {
      this.$bvModal.hide("modal-confirm-delete");
      this.$emit("clear");
    },
    confirm() {
      this.$bvModal.hide("modal-confirm-delete");
      this.$emit("confirmed");
    },
  },
  watch: {
    action(valueNew, valueOld) {
      if (valueNew == "delete") {
        this.init();
      } else if (valueNew == '' && valueOld == 'delete') {
        this.clear();
      }
    },
  }
};
</script>